<template>
    <div>
        <h1>Setting</h1>
        <div class="row justify-content-center">
            <div class="col-sm-8">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>{{ auth_type }}</label>
                            <div class="input-group">
                                <input
                                    v-model="auth_url"
                                    type="text"
                                    class="form-control"
                                    disabled
                                />
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-dark"
                                        type="button"
                                        @click="openAuth"
                                    >
                                        Open
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Email</label>
                            <div class="input-group">
                                <input
                                    v-model.trim="new_email"
                                    type="email"
                                    class="form-control"
                                />
                                <div class="input-group-append">
                                    <button
                                        :disabled="loading"
                                        class="btn btn-danger text-white"
                                        type="button"
                                        @click="setEmail"
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                            <small class="form-text text-muted"
                                >We will contact you via this email.</small
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'

import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            customer: null,
            new_email: '',
            loading: true,
        }
    },
    computed: {
        auth_type() {
            if (!this.customer || !this.customer.auth) {
                return ''
            }

            if (this.customer.auth.hasOwnProperty('facebook')) {
                return 'Facebook'
            }
            if (this.customer.auth.hasOwnProperty('google')) {
                return 'Google'
            }

            return ''
        },
        auth_url() {
            if (!this.customer) {
                return ''
            }

            return this.auth_type === 'Facebook'
                ? 'https://fb.com/' + this.customer.auth.facebook
                : 'https://plus.google.com/' + this.customer.auth.google
        },
    },
    created() {
        this.getCustomer()
    },
    methods: {
        getCustomer() {
            var self = this

            superagent
                .get(config.url_api + '/customer')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.customer = res.body
                    self.new_email = self.customer.email
                    return
                })
        },
        openAuth() {
            window.open(this.auth_url)
        },
        setEmail() {
            var self = this

            if (this.customer.email == this.new_email) {
                return
            }

            self.loading = true
            superagent
                .put(config.url_api + '/customer/email')
                .type('form')
                .query(auth.getAuthQs())
                .send({ email: self.new_email })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK('')
                    self.customer.email = self.new_email
                    return
                })
        },
    },
}
</script>